import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { discussionService } from '../services/api';
import { Discussion } from '../types';
import DiscussionCard from '../components/DiscussionCard';

const SearchPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [results, setResults] = useState<Discussion[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const query = searchParams.get('q') || '';

  useEffect(() => {
    if (!query) {
      setResults([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    discussionService
      .search(query)
      .then((response) => setResults(response.data))
      .catch(() => setError('Search failed'))
      .finally(() => setLoading(false));
  }, [query]);

  return (
    <div className="page-shell">
      <div className="container">
        <div className="page-intro">
          <div>
            <p className="eyebrow">Search</p>
            <h1 className="page-heading">Results for "{query}"</h1>
          </div>
        </div>

        {!query && (
          <div className="card">
            <p className="page-copy">Search published and archived discussions by title, wording, or workflow keywords. If you just want to browse, open the archive.</p>
            <div className="module-actions">
              <Link to="/archive" className="btn btn-secondary">Open archive</Link>
            </div>
          </div>
        )}

        {loading && <div className="card">Loading results...</div>}
        {error && <div className="alert alert-error">{error}</div>}
        {!loading && !error && query && results.length === 0 && <div className="card">No matching discussions found. Try broader wording, or browse the archive.</div>}
        {!loading && !error && results.length > 0 && (
          <div className="discussion-stack">
            {results.map((discussion) => (
              <DiscussionCard key={discussion.id} discussion={discussion} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchPage;
